import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row, Button, Form, Card } from "react-bootstrap";
import TextInputOption from "./TextInputOption";

const HandleOptions = ({ messages, handleOptionSelect, handleTextSubmit }) => {
  const [loading, setLoading] = useState(false);
  // console.log(messages);
  const fmtPKR = (usd, pkrRate) =>
    Math.round(usd * pkrRate).toLocaleString("en-PK");

  const optionMessages = messages.filter((msg) => msg.isOption);

  if (!optionMessages || optionMessages.length === 0) {
    return null;
  }

  return (
    <>
      <div className="row">
        {optionMessages.map((msg, index) => (
          <React.Fragment key={index}>
            {msg.inputtype === "button" ? (
              <Button
                key={index}
                variant="secondary"
                style={{ backgroundColor: "#1bb367" }}
                className="border-0 w-75 mb-2 chatOptions"
                onClick={() => handleOptionSelect(msg)}
              >
                {msg.text}
              </Button>
            ) : msg.inputtype === "textinput" ? (
              <TextInputOption
                key={index}
                msg={msg}
                handleTextSubmit={handleTextSubmit}
              />
            ) : msg.price && msg.price ? (
              //This is old code which is replaced by the code below

              // <div className="col-6" onClick={() => handleOptionSelect(msg)}>
              //   <div className="card border border-success">
              //     <div className="card-body text-center">
              //       {/* Package Name */}
              //       <h6>{msg.name}</h6>

              //       {/* Price */}
              //       <h6 className="mt-2 mb-2">
              //         <strong style={{ fontSize: "15px" }}>
              //           Rs {msg.price}
              //         </strong>
              //       </h6>

              //       {/* Description */}
              //       <small
              //         className="text-muted text-start"
              //         dangerouslySetInnerHTML={{ __html: msg.desc }}
              //       />
              //     </div>
              //   </div>
              // </div>

              <div
                className="col-12 col-md-6 d-flex justify-content-center gy-2"
                onClick={() => handleOptionSelect(msg)}
              >
                <div
                  className="border border-success rounded-top p-0"
                  style={{ width: "30rem" }}
                >
                  <div className="text-center d-flex flex-column  rounded-top">
                    {/* Package Name */}

                    <div
                      className="text-white text-center py-2 fw-bold rounded-top"
                      style={{
                        backgroundColor: "#1bb367",
                        fontSize: "12px",
                        letterSpacing: "0.08em",
                      }}
                    >
                      {msg.name}
                    </div>
                    <div
                      className="text-center py-3"
                      style={{
                        backgroundColor: "#0d4f5c",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      <small
                        className="d-block"
                        style={{
                          fontSize: "10px",
                          letterSpacing: "0.1em",
                          textTransform: "uppercase",
                          color: "rgba(255,255,255,0.6)",
                        }}
                      >
                        Final Premium Payable (PKR)
                      </small>
                      <p
                        className="mb-0 fw-bold"
                        style={{ fontSize: "36px", color: "#d4a843" }}
                      >
                        Rs. {fmtPKR(msg.result.final, msg.result.pkrRate)}
                        {/* Rs. {msg.result.finalPKR.toFixed(2)} */}
                      </p>
                      <small
                        style={{
                          color: "rgba(255,255,255,0.55)",
                          fontSize: "12px",
                        }}
                      >
                        ${msg.result.final.toFixed(2)} USD
                      </small>
                    </div>
                    <table className="table table-sm table-bordered mb-0">
                      <tbody>
                        <tr>
                          <td
                            style={{
                              fontSize: "12px",
                              color: "#6c757d",
                              width: "55%",
                            }}
                          >
                            Base Premium (USD)
                          </td>
                          <td className="fw-bold text-end">
                            ${msg.result.base.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ fontSize: "12px", color: "#6c757d" }}>
                            Base Premium (PKR)
                          </td>
                          <td className="fw-bold text-end">
                            {/* Rs. {fmtPKR(result.base)} */}
                            Rs. {fmtPKR(msg.result.base, msg.result.pkrRate)}
                          </td>
                        </tr>
                        <tr
                          style={{
                            backgroundColor:
                              msg.result.loading.rate > 0
                                ? "#fff8e1"
                                : undefined,
                          }}
                        >
                          <td style={{ fontSize: "12px", color: "#6c757d" }}>
                            Age Loading
                            {msg.result.loading.note ? (
                              <>
                                <br />
                                <small
                                  className="text-muted"
                                  style={{ fontSize: "10px" }}
                                >
                                  {msg.result.loading.note}
                                </small>
                              </>
                            ) : null}
                          </td>
                          <td
                            className="fw-bold text-end"
                            style={{
                              color:
                                msg.result.loading.rate > 0
                                  ? "#b8860b"
                                  : "#1a5c2e",
                            }}
                          >
                            {msg.result.loading.label}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ fontSize: "12px", color: "#6c757d" }}>
                            Medical Deductible
                          </td>
                          <td className="fw-bold text-end">
                            Rs.{" "}
                            {Math.round(
                              msg.result.deductibleUsd * msg.result.pkrRate,
                            ).toLocaleString("en-PK")}
                          </td>
                        </tr>
                        <tr className="table-success">
                          <td className="fw-bold" style={{ fontSize: "13px" }}>
                            Final Premium (PKR)
                            <br />
                            <small
                              className="fw-normal text-muted"
                              style={{ fontSize: "10px" }}
                            >
                              Base × (1 + Age Loading) × PKR rate
                            </small>
                          </td>
                          <td
                            className="fw-bold text-end"
                            style={{ fontSize: "18px", color: "#0d4f5c" }}
                          >
                            Rs. {fmtPKR(msg.result.base, msg.result.pkrRate)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="d-flex justify-content-center">
                      <span
                        className="btn btn-success w-50 p-2 rounded-pill border-0 my-4"
                        style={{ backgroundColor: "#1bb367" }}
                      >
                        Pay Now
                      </span>
                    </div>
                    {/* Price */}
                    {/* <p className="mt-2">
                      <strong style={{ fontSize: "15px" }}>
                        Rs {msg.price}
                      </strong>
                    </p> */}

                    {/* Description */}
                    {/* <small
                      className="text-muted text-start"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                      }}
                      dangerouslySetInnerHTML={{ __html: msg.desc }}
                    /> */}
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-12">
                <div className="p-0">
                  {/* Dynamically render button or input */}
                  {msg.inputtype === "text" ? (
                    <Form.Control
                      type="text"
                      placeholder="Enter your text here"
                      className="w-75 mb-2"
                      onBlur={() => handleOptionSelect(msg)} // Handle when user finishes input
                    />
                  ) : (
                    <Button
                      variant="secondary"
                      style={{ backgroundColor: "#1bb367" }}
                      className="border-0 w-75 mb-2 chatOptions"
                      onClick={() => handleOptionSelect(msg)}
                    >
                      <p className="mb-0">{msg.name}</p>
                    </Button>
                  )}
                </div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default HandleOptions;
